import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function SolutionSection() {
  return <section className="py-8 sm:py-12 lg:py-16 bg-bone relative overflow-hidden" data-id="element-1290">
      {/* Decorative background element */}
      <div className="absolute top-0 left-0 w-full h-full opacity-5 pointer-events-none" data-id="element-1291">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] sm:w-[800px] h-[600px] sm:h-[800px] bg-ginger rounded-full blur-[120px]" data-id="element-1292" />
      </div>

      <div className="max-w-6xl mx-auto px-4 relative z-10" data-id="element-1293">
        {/* Header Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 lg:gap-12 items-center mb-8 sm:mb-10 lg:mb-12" data-id="element-1294">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6
        }} data-id="element-1295">
            <h2 className="text-ginger/60 font-light tracking-[0.2em] uppercase mb-2 sm:mb-3 text-xs" data-id="element-1296">
              The GINEXT Difference
            </h2>
            <h3 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light text-charcoal mb-4 sm:mb-6 leading-tight tracking-tight" data-id="element-1297">
              Stop Numbing. <br data-id="element-1298" />
              <span className="text-ginger" data-id="element-1299">Start Releasing.</span>
            </h3>
            <div className="h-px w-16 sm:w-20 bg-ginger/30 mb-4 sm:mb-6" data-id="element-1300" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-sm sm:text-base lg:text-lg text-charcoal leading-relaxed space-y-3 sm:space-y-4 font-light" data-id="element-1301">
            <p data-id="element-1302">GINEXT isn't another menthol gel competing to feel stronger.</p>
            <p data-id="element-1303">
              It's a circulation-supporting botanical oil designed to create
              deep, steady warmth, the signal your body recognizes as permission
              to loosen, relax, and move fluid again.
            </p>
            <p className="font-normal" data-id="element-1304">
              No cold shock. No burning heat. No greasy film.
            </p>
            <p className="text-ginger font-normal text-base sm:text-lg lg:text-xl" data-id="element-1305">
              Just fast, noticeable support that feels natural and actually
              holds.
            </p>
          </motion.div>
        </div>

        {/* Images Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8" data-id="element-1306">
          {/* Lifestyle Image - Desktop Only */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="hidden lg:block relative" data-id="element-1307">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-ginger/10 lg:h-[500px]" data-id="element-1308">
              <img src="https://cdn.magicpatterns.com/uploads/866iV7ge2fNSNhwjXMzQs9/u8896349413_A_clean_modern_flat-lay_image_featuring_ginger_ro_292d1659-ce47-4dbf-92f7-0123bab45f9d_0.png" alt="Natural botanical ingredients: ginger root, rosemary, eucalyptus, and black pepper" className="w-full h-auto lg:w-full lg:h-full lg:object-cover" loading="lazy" decoding="async" width="800" height="600" data-id="element-1309" />
            </div>
            <p className="text-center mt-3 sm:mt-4 text-charcoal-light italic text-xs sm:text-sm font-light" data-id="element-1310">
              Experience natural relief that supports your body's healing
              process
            </p>
          </motion.div>

          {/* Product Image */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="relative" data-id="element-1311">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-ginger/10 lg:h-[500px]" data-id="element-1312">
              <img src="https://cdn.magicpatterns.com/uploads/vTGmLdngBLwQnnLehwkjMF/GINEXT_BOTTLE_.png" alt="GINEXT Ginger Oil with Natural Botanical Ingredients" className="w-full h-auto lg:w-full lg:h-full lg:object-cover" loading="lazy" decoding="async" width="800" height="600" data-id="element-1313" />
              <div className="absolute inset-0 bg-gradient-to-t from-ginger/10 via-transparent to-transparent pointer-events-none" data-id="element-1314" />
            </div>

            <p className="text-center mt-3 sm:mt-4 text-charcoal-light italic text-xs sm:text-sm font-light" data-id="element-1315">
              High-potency ginger and botanical oils, formulated for deep,
              natural warmth
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}